import DOMPurify from 'dompurify';

interface HtmlParserOptions {}
export function CleanHtml(text: string, options?: HtmlParserOptions) {
  const cleanedHtml = DOMPurify.sanitize(text, {
    USE_PROFILES: { html: true },
  });

  return cleanedHtml;
}
